"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallAsteroid = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
var CardRenderer_1 = require("../render/CardRenderer");
var SmallAsteroid = (function (_super) {
    __extends(SmallAsteroid, _super);
    function SmallAsteroid() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SMALL_ASTEROID,
            tags: [Tags_1.Tags.SPACE],
            cost: 10,
            metadata: {
                cardNumber: '209',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.temperature(1).br;
                    b.minus().plants(2).any;
                }),
                description: 'Increase temperature 1 step. Remove up to 2 plants from any player.',
            },
        }) || this;
    }
    SmallAsteroid.prototype.canPlay = function (player) {
        var canRaiseTemperature = player.game.getTemperature() < constants_1.MAX_TEMPERATURE;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS) && canRaiseTemperature) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST, { titanium: true });
        }
        return true;
    };
    SmallAsteroid.prototype.play = function (player) {
        player.game.increaseTemperature(player, 1);
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 2));
        return undefined;
    };
    return SmallAsteroid;
}(Card_1.Card));
exports.SmallAsteroid = SmallAsteroid;
//# sourceMappingURL=SmallAsteroid.js.map